/* eslint-disable import/prefer-default-export */
import * as ReduxHelpers from '@src/utils/reduxHelpers'

//  Action Types
const prefix = 'cam/usage'
export const GET_STAT_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'GET_STAT_SUCCESS'
)
export const ON_CHANGE_COLUMN_FILTER = ReduxHelpers.Types.createActionType(
  prefix,
  'ON_CHANGE_COLUMN_FILTER'
)
export const SET_TIMESTAMP = ReduxHelpers.Types.createActionType(
  prefix,
  'SET_TIMESTAMP'
)

export const SET_TABLE_OPTIONS = ReduxHelpers.Types.createActionType(
  prefix,
  'SET_TABLE_OPTIONS'
)

export const ON_CHANGE_SEARCH_FILTER = ReduxHelpers.Types.createActionType(
  prefix,
  'ON_CHANGE_SEARCH_FILTER'
)
export const GET_USER_USAGE_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'GET_USER_USAGE_SUCCESS'
)
export const REQUEST_PENDING = ReduxHelpers.Types.createActionType(
  prefix,
  'REQUEST_PENDING'
)
export const CLEANING = ReduxHelpers.Types.createActionType(
  prefix,
  'USER_USAGE_CLEANING'
)
export const CLEANER_STAT = ReduxHelpers.Types.createActionType(
  prefix,
  'CLEANER_STAT'
)
